import React, { useContext, useState, useEffect } from "react"; // eslint-disable-line no-unused-vars
import { State } from "../../store/state";
import { getCardImages, getCardImageGroupings } from "../../store/actions";
import ReactCrop from "react-image-crop";
import Dropzone from "react-dropzone";
import {
  Button,
  Grid,
  TextField,
  MenuItem,
  Typography,
  LinearProgress,
  Hidden,
} from "@material-ui/core";

import { useAuth0 } from "@auth0/auth0-react";

export default function CardImage(props) {
  const { state, dispatch } = useContext(State);
  const [imagesReady, setImagesReady] = useState(false);
  const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();

  const [cardImageGroupings, setCardImageGroupings] = useState([]);
  const [cardImages, setCardImages] = useState([]);

  const defaultCrop = {
    x: 0,
    y: 0,
    unit: "%",
    width: 100,
    aspect: 487 / 303,
  };

  const [src, setSRC] = useState();
  const [crop, setCrop] = useState(defaultCrop);
  const [imageRef, setImageRef] = useState(null);

  useEffect(() => {
    if (!isLoading) {
      getCardImageGroupings(getAccessTokenSilently, dispatch).then(
        (getCardImageGroupingsResponse) => {
          setCardImageGroupings(getCardImageGroupingsResponse.groups);
          if (!props.selectedImageGroupingId) {
            props.onSelectImageGroupingId(
              getCardImageGroupingsResponse.defaultImageGroupingId
            );
          }
        }
      );
    }
  }, [isLoading, isAuthenticated]);

  useEffect(() => {
    if (props.selectedImageGroupingId) {
      setImagesReady(false);
      getCardImages(
        props.selectedImageGroupingId,
        getAccessTokenSilently,
        dispatch
      ).then((getCardImagesResponse) => {
        setImagesReady(true);
        setCardImages(getCardImagesResponse.imageUrls);
      });
    }
  }, [props.selectedImageGroupingId]);

  useEffect(() => {
    generateImage(crop);
  }, [imageRef]);

  const generateImage = (crop) => {
    if (imageRef && crop.width && crop.height) {
      const canvas = document.createElement("canvas");
      const scaleX = imageRef.naturalWidth / imageRef.width;
      const scaleY = imageRef.naturalHeight / imageRef.height;
      canvas.width = crop.width * scaleX;
      canvas.height = crop.height * scaleY;
      console.log({
        nw: imageRef.naturalWidth,
        nh: imageRef.naturalHeight,
        iw: imageRef.width,
        ih: imageRef.height,
        cropX: crop.x,
        cropY: crop.y,
        scaleX: scaleX,
        scaleY: scaleY,
        cw: canvas.width,
        ch: canvas.height,
      });
      const ctx = canvas.getContext("2d");
      ctx.drawImage(
        imageRef,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        canvas.width,
        canvas.height
      );
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            console.error("Canvas is empty");
            return;
          }
          blob.name = "newFile.jpeg";
          let dataUrl = canvas.toDataURL("image/jpeg");
          props.onSelectCardImage(dataUrl);
        },
        "image/jpeg",
        1
      );
    }
  };

  const renderCustomImageToggle = (fullWidth) => {
    return (
      <Dropzone
        accept="image/*"
        multiple={false}
        onDrop={(files) => {
          if (files && files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener("load", () => {
              setSRC(reader.result);
            });
            reader.readAsDataURL(files[0]);
          }
        }}
        onFileDialogCancel={() => {
          setSRC(null);
        }}
      >
        {({ getRootProps, getInputProps }) => {
          return (
            <div
              {...getRootProps()}
              style={{
                display: "inline-block",
                width: fullWidth ? "100%" : "auto",
              }}
            >
              <input {...getInputProps()} />
              <Button
                variant="outlined"
                color="secondary"
                fullWidth={fullWidth}
                className={props.classes.cardimagetoggle}
              >
                Upload an Image
              </Button>
            </div>
          );
        }}
      </Dropzone>
    );
  };

  const renderDesignOptions = () => {
    if (cardImageGroupings.length > 0) {
      return (
        <TextField
          variant="outlined"
          color="primary"
          fullWidth={true}
          select={true}
          value={props.selectedImageGroupingId}
          className={props.classes.cardimagecategories}
          onChange={(event) => {
            props.onSelectImageGroupingId(event.target.value);
          }}
        >
          {cardImageGroupings.map((cardImageGrouping) => {
            if (
              cardImageGrouping.cardImageGroupingId != "My Custom Images" ||
              isAuthenticated
            ) {
              return (
                <MenuItem
                  key={cardImageGrouping.cardImageGroupingId}
                  value={cardImageGrouping.cardImageGroupingId}
                >
                  {cardImageGrouping.displayName}
                </MenuItem>
              );
            }
          })}
        </TextField>
      );
    } else {
      return null;
    }
  };

  const renderStockImages = () => {
    return (
      <Grid
        container
        item
        xs={12}
        spacing={2}
        className={props.classes.cardimagestockimages}
      >
        {!imagesReady && (
          <Grid item xs={12}>
            <LinearProgress color="secondary" />
          </Grid>
        )}
        {cardImages.map((cardImage, index) => {
          return (
            <Grid item xs={4} sm={2} key={index}>
              <div
                className={props.classes.cardimagethumbnail}
                onClick={() => {
                  props.onSelectCardImage(cardImage);
                }}
              >
                <div
                  className={
                    props.selectedCardImage == cardImage
                      ? props.classes.cardimageselectedCardImage
                      : props.classes.cardimagecardImage
                  }
                  style={{
                    backgroundImage: "url('" + cardImage + "')",
                  }}
                >
                  <img
                    className={props.classes.cardimageoverlay}
                    src={props.cardOverlay}
                  />
                </div>
              </div>
            </Grid>
          );
        })}
      </Grid>
    );
  };

  const renderCustomImages = () => {
    if (src) {
      return (
        <Grid item xs={12}>
          <div className={props.classes.cardimagecrop}>
            <ReactCrop
              src={src}
              crop={crop}
              ruleOfThirds
              locked={true}
              onImageLoaded={(image) => {
                setImageRef(image);
              }}
              onComplete={(crop) => {
                generateImage(crop);
              }}
              onChange={(updatedCrop) => {
                setCrop(updatedCrop);
              }}
            />
          </div>
        </Grid>
      );
    } else {
      return null;
    }
  };

  return (
    <Grid
      container
      item
      xs={12}
      spacing={2}
      className={props.classes.cardimagemain}
    >
      <Grid item xs={12} sm={4}>
        <Typography
          variant="h5"
          color="primary"
          className={props.classes.cardimagetitle}
        >
          Card Image
        </Typography>
        <Hidden xsDown={true}>{renderCustomImageToggle(false)}</Hidden>
      </Grid>
      <Hidden smUp={true}>
        <Grid item xs={12}>
          {renderCustomImageToggle(true)}
        </Grid>
      </Hidden>
      <Grid item xs={12} sm={8}>
        {renderDesignOptions()}
      </Grid>
      {renderStockImages()}
      {renderCustomImages()}
    </Grid>
  );
}
